import useDistribution from './useDistribution';

export default function useAds(path = []) {
  const adsEnabled = useDistribution(['ads', 'enabled']);
  const adsConfig = useDistribution(['ads', ...path]);
  if (!adsEnabled) return;
  return adsConfig;
}
